import { client } from './client'
import type { components } from './auto-gen-types'
import type { ReportAPIInterface } from './api-switcher'

export type CreateReportRequest = components['schemas']['CreateReportRequest']

export const ReportAPI: ReportAPIInterface = {
  createReport: body => {
    // TODO: Connect album reporting once the real API contract supports it.
    if (body.target_type === 'album') {
      console.log('createReport (album not implemented)', body)
      return Promise.resolve({
        error: {code: 501, message: 'Not Implemented'},
        response: new Response('', {status: 501}),
      })
    }
    return client.POST('/report', {body: {...body, target_type: body.target_type}})
  },
}
